module.exports = __webpack_public_path__ + "img/indoor2.37438b36.jpg";